
import * as startTempConst from './constants';

export default {
    [startTempConst.startTempList](state, res) {
        state.list = res.list
        state.total = res.total
    },
};
